import './BoostSection.css';
import { BOOK_DEMO_URL } from '../../constants/urls';

const TIMELINE_STEPS = [
  {
    label: 'Today',
    title: 'Sign up and reactivate',
    description:
      'Onboard in minutes and book a setup call with our team. Connect to your existing CRM and start your reactivation campaign.',
  },
  {
    label: 'Day 3',
    title: 'Reviews start rolling in',
    description:
      'Your previous customers will start leaving you those hard earned reviews and we reply and repost to social media for you. No need to worry.',
  },
  {
    label: 'Day 7',
    title: 'Win jobs again',
    description:
      "Your business will rank higher on Google and be seen faster thanks to the new reviews. You'll spend less time building trust with leads, and more time closing deals.",
  },
] as const;

export function BoostSection() {
  return (
    <section className="boost" aria-labelledby="boost-heading">
      <div className="container boost__grid">
        <div className="boost__content">
          <h2 id="boost-heading" className="boost__title">
            Boost your blue-collar business
          </h2>
          <p className="boost__subtitle">
            What you could achieve in just 7 days by adding Review Lumen to your
            business.
          </p>
          <div className="boost__ctas">
            <a href="#pricing" className="btn btn--primary btn--lg">
              Start getting reviews
            </a>
            <a
              href={BOOK_DEMO_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn--secondary btn--lg boost__cta-demo"
            >
              Book a demo
            </a>
          </div>
          <div className="boost-stat-card">
            <div className="boost-stat-card__stat">
              <span className="boost-stat-card__number">+4,356%</span>
              <p className="boost-stat-card__desc">
                Increased reviews from 23 to 1,025 reviews
              </p>
            </div>
            <hr className="boost-stat-card__divider" />
            <div className="boost-stat-card__profile">
              <img
                className="boost-stat-card__avatar"
                src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=80&h=80&q=80"
                alt="Davin Hand"
              />
              <div>
                <p className="boost-stat-card__name">Davin Hand</p>
                <p className="boost-stat-card__company">30a Blaze Beach Bonfires</p>
              </div>
            </div>
          </div>
        </div>

        <div className="boost__timeline-card">
          <ol className="timeline">
            {TIMELINE_STEPS.map((step, index) => (
              <li key={step.label} className="timeline__step">
                <span className="timeline__label">{step.label}</span>
                <div className="timeline__track">
                  <span className="timeline__dot" aria-hidden="true" />
                  {index < TIMELINE_STEPS.length - 1 && (
                    <span className="timeline__line" aria-hidden="true" />
                  )}
                </div>
                <div className="timeline__content">
                  <h3 className="timeline__title">{step.title}</h3>
                  <p className="timeline__text">{step.description}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
